import {Grid, Box, styled} from '@mui/material';
import {Color} from '../../../common/theme';
import {useNavigate} from 'react-router-dom';

const BackgroundBox = styled(Box)({
    paddingTop: 108,
    paddingBottom: 96,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
    backgroundColor: Color.SEA_GREEN,
});

export const HeroSection = () => {
    const navigateTo = useNavigate();

    return (
        <BackgroundBox>
            <Grid container>
                <Grid item md={3} />
                <Grid item md={6}>
                    <span
                        style={{
                            fontSize: 32,
                            color: Color.WHITE,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        <center>Socialmart</center>
                    </span>
                </Grid>
            </Grid>
            <Grid style={{marginTop: 12}} container>
                <Grid item md={3} />
                <Grid item md={6}>
                    <span
                        style={{
                            fontSize: 20,
                            color: Color.WHITE,
                            fontWeight: 200,
                            fontFamily: 'Poppins',
                        }}>
                        <center>Home on the web for every kirana!</center>
                    </span>
                </Grid>
            </Grid>
            <Grid style={{marginTop: 45}} container>
                <Grid item md={4} />
                <Grid item md={4}>
                    <Box
                        style={{
                            backgroundColor: Color.FELDGRAU,
                            paddingLeft: 32,
                            paddingRight: 32,
                            paddingTop: 15,
                            paddingBottom: 15,
                            borderRadius: 32,
                            cursor: 'pointer',
                        }}>
                        <span
                            onClick={() => {
                                navigateTo('/home');
                            }}
                            style={{
                                fontSize: 20,
                                color: Color.ASH_GRAY,
                                fontWeight: 700,
                                fontFamily: 'Poppins',
                            }}>
                            <center>Get started</center>
                        </span>
                    </Box>
                </Grid>
            </Grid>
        </BackgroundBox>
    );
};
